export default __webpack_public_path__ + "static/media/footer.d73c13ca.png";